import StatisticContent from "./StatisticContent.component";

export default StatisticContent;
